import uniq from 'lodash/uniq';
import { combineReducers } from 'redux';
import { actions as apiActions } from 'zender-api-client';

import * as appActions from '../actions';

const initialUiState = {
	quiz: {
		doneQuestionIds: [],
	},
};

export function interactions(state = {}, action = {}) {
	switch (action.type) {
		// ================================
		// API ACTIONS
		// ================================
		case apiActions.stream.apiActionTypes.GET_STREAM.SUCCESS:
			return Object.assign(
				{},
				state,
				...[
					...Object.keys(action.payload.response.interactions),
					'quiz-toolate',
					'quiz-redeem',
					'quiz-backInTheGame',
					'quiz-highscore',
					'quiz-eliminated',
					'quiz-winner',
					'poll-results',
					'poll-thanks-for-voting',
					'notification',
					'login',
					'leaderboard',
					'get-extra-lives',
					'profile',
					'profile-blocked',
					'profile-apply-referral',
					'profile-edit-profile',
					'settings',
					'settings-language',
					'settings-push-notifications',
					'settings-rules',
					'settings-privacy-policy',
					'settings-terms-of-use',
					'settings-remove-account',
					'menu',
					'internet-connection-failed',
					'image-upload',
					'image-upload-result',
					'shoutbox-block-user',
					'shoutbox-block-user-success',
					'quiz-teams',
					'team-join',
					'team-create',
					'team-overview',
					'team-members',
					'team-add-members',
					'team-manage-member',
				].map(interaction => Object.assign(
					{},
					{
						[interaction]: {
							expanded: false,
							tabIndex: 0,
							visible: true,
							scrollTop: 0,
							scrollLeft: 0,
						},
					}
				))
			);

		default:
			return state;
	}
}

export function data(state = initialUiState, action = {}) {
	switch (action.type) {
		case apiActions.quiz.pushActionTypes.QUIZ_RESET:
			return initialUiState;
		case appActions.ui.uiActionTypes.QUESTION_DONE: {
			const { questionId } = action.payload;
			if (questionId) {
				return {
					...state,
					quiz: {
						...state.quiz,
						doneQuestionIds: uniq([
							...state.quiz.doneQuestionIds,
							questionId,
						]),
					},
				};
			}
			return state;
		}
		default: {
			return state;
		}
	}
}

const ui = combineReducers({
	data,
	interactions,
});

export default ui;



// WEBPACK FOOTER //
// ./src/reducers/ui.js